/* Froens PLP 2026: desplegables de filtros (solo desktop) */
(function(){
  var mq = window.matchMedia('(min-width:768px)');
  function root(){ return document.querySelector('.froens-plp'); }
  function groups(){ return Array.prototype.slice.call(document.querySelectorAll('.froens-plp .sidebar__filter__group')); }
  function closeAll(except){ groups().forEach(function(g){ if(g!==except) g.classList.remove('fpl-open'); }); }
  function markActive(){
    groups().forEach(function(g){
      g.classList.toggle('fpl-has-active', !!g.querySelector('[data-accordion-body] input:checked, .sidebar__item--active'));
    });
  }
  function place(g){
    g.classList.remove('fpl-right');
    var b = g.querySelector('[data-accordion-body]'); if(!b) return;
    var r = b.getBoundingClientRect();
    if(r.right > window.innerWidth - 12) g.classList.add('fpl-right');
  }
  document.addEventListener('click', function(e){
    if(!mq.matches || !root()) return;
    var t = e.target.closest && e.target.closest('.froens-plp [data-accordion-trigger]');
    if(t){
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var g = t.closest('.sidebar__filter__group');
      var open = !g.classList.contains('fpl-open');
      closeAll(g);
      g.classList.toggle('fpl-open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(open) place(g);
      return;
    }
    if(!e.target.closest('.froens-plp .sidebar__filter__group')) closeAll();
  }, true);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeAll(); });

  function addCta(){
    var outer = document.querySelector('.froens-plp .collection__filters__outer');
    if(!outer || outer.querySelector('.fpl-drawer-cta')) return;
    var d = document.createElement('div'); d.className = 'fpl-drawer-cta';
    d.innerHTML = '<button type="button">Ver productos</button>';
    d.firstChild.addEventListener('click', function(){
      var c = document.querySelector('.froens-plp .drawer__close'); if(c) c.click();
    });
    outer.appendChild(d);
  }

  function init(){
    if(!root()) return;
    markActive(); addCta();
    var aside = document.querySelector('.froens-plp .collection__filters__wrapper');
    if(aside && window.MutationObserver){
      new MutationObserver(function(){ markActive(); addCta(); }).observe(aside,{childList:true,subtree:true});
    }
    document.addEventListener('change', function(e){
      if(e.target.closest && e.target.closest('.froens-plp [data-sidebar-filter-form]')) setTimeout(markActive,60);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
